import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function FailedAttempts() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-cream-100 py-16 md:py-24" ref={ref} data-id="element-34">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-36">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900 mb-3" data-id="element-37">
            Lo que ya intentaste y no funcionó
          </h2>

          <div className="w-16 h-1 bg-gold-500 mb-10" data-id="element-38" />
        </motion.div>

        <motion.ul className="space-y-5" role="list" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-39">
          <motion.li variants={itemVariants} className="flex items-start gap-4" data-id="element-40">
            <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-41" />
            <p className="font-body text-lg text-gray-700 leading-relaxed" data-id="element-42">
              Buscar información en grupos de Facebook o foros donde cada
              persona tiene una opinión distinta y desactualizada.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start gap-4" data-id="element-43">
            <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-44" />
            <p className="font-body text-lg text-gray-700 leading-relaxed" data-id="element-45">
              Intentar aplicar a apartamentos corporativos que exigen un puntaje
              de crédito que aún no tienes.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start gap-4" data-id="element-46">
            <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-47" />
            <p className="font-body text-lg text-gray-700 leading-relaxed" data-id="element-48">
              Confiar en que tu licencia de conducir o seguro de auto de tu país
              de origen funcionará igual en el sistema americano.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start gap-4" data-id="element-49">
            <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-50" />
            <p className="font-body text-lg text-gray-700 leading-relaxed" data-id="element-51">
              Creer que el orden de los trámites no importa, cuando en realidad
              un error en tu primera dirección puede bloquear tu cuenta bancaria
              por semanas.
            </p>
          </motion.li>
        </motion.ul>
      </div>
    </section>;
}